/* eslint-disable no-undef */
// prettier-ignore
import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  RectangleBar: styled('div')({
    height: '4px',
    backgroundColor: '#04682E',
    margin: '10px 0 30px 0'
  }),

  FormSection: styled('section')(({ theme }) => ({
    display: 'flex',
    gap: '20px',
    marginBottom: '30px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      gap: '15px'
    },
    '&:last-child': {
      marginTop: '30px',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        gap: '10px'
      }
    }
  })),

  InputContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '&': {
      width: 'auto'
    },
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      marginBottom: '15px',
      '&:last-child': {
        marginBottom: 0
      }
    }
  })),

  Label: styled('label')(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px'
    },
    '&.required::after': {
      content: '"*"',
      color: '#ff0000',
      marginLeft: '4px'
    }
  })),

  Input: styled('input')(({ theme }) => ({
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
      fontSize: '13px'
    },
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E',
      boxShadow: '0 0 0 2px rgba(4, 104, 46, 0.2)'
    },
    '&:disabled': {
      backgroundColor: '#f8f8f8',
      cursor: 'not-allowed'
    }
  })),

  Select: styled('select')(({ theme }) => ({
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    backgroundColor: '#fff',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
      fontSize: '13px'
    },
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E',
      boxShadow: '0 0 0 2px rgba(4, 104, 46, 0.2)'
    }
  })),

  Button: styled(Button)(({ theme }) => ({
    padding: '12px 30px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    backgroundColor: '#04682E',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
      fontSize: '13px',
      width: '48%'
    },
    '&:hover': {
      backgroundColor: '#035723'
    }
  })),

  CancelButton: styled(Button)(({ theme }) => ({
    padding: '12px 30px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    backgroundColor: '#dc3545',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
      fontSize: '13px',
      width: '48%'
    },
    '&:hover': {
      backgroundColor: '#bb2d3b'
    }
  })),

  ImagePreview: styled('div')(({ theme }) => ({
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '2px solid #ddd',
    [theme.breakpoints.down('sm')]: {
      width: '80px',
      height: '80px',
      margin: '0 auto'
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  })),

  SectionFilters: styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    margin: '0 auto',
    marginBottom: '25px'
  }),

  FlexContainer: styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px'
  }),

  ShowText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529'
  }),

  SelectContainer: styled('div')({
    select: {
      padding: '5px',
      fontSize: '16px',
      border: '0.5px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      }
    }
  }),

  RecordsText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529'
  }),

  UserCard: styled('div')({
    width: '980px',
    height: 'auto',
    minHeight: '75px',
    backgroundColor: '#FEF7FF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: '10px',
    gap: '20px'
  }),

  UserIcon: styled('div')({
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }),

  UserInfo: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '5px'
  }),

  UserName: styled('div')({
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    color: '#212529'
  }),

  UserTypeBadge: styled('span')<{ type: string }>(({ type }) => ({
    backgroundColor: {
      Corretor: '#04682E',
      Secretária: '#FF0000',
      Proprietário: '#000000',
      Administrador: '#808080'
    }[type],
    color: 'white',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    marginLeft: '10px'
  })),

  Pagination: styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '15px',
    marginRight: '10px',
    paddingBottom: '25px',

    '& button': {
      padding: '8px 16px',
      cursor: 'pointer',
      color: 'white',
      border: '1px solid #ddd',
      backgroundColor: '#2C62C7',
      borderRadius: '5px',
      '&.active': {
        backgroundColor: '#0B327A',
        color: 'white'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: '#2C62C7',
        color: 'white'
      }
    }
  })
};
